"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SUPPORTED_REPORTS_REQUEST_TYPES = exports.ReportType = void 0;
var ReportType;
(function (ReportType) {
    ReportType["TRAINING"] = "TRAINING";
    ReportType["SUBMITTED_MODERATED"] = "SUBMITTED_MODERATED";
    ReportType["NOT_SUBMITTED_MODERATED"] = "NOT_SUBMITTED_MODERATED";
    ReportType["SUBMITTED_EXAMINED"] = "SUBMITTED_EXAMINED";
    ReportType["NOT_SUBMITTED_EXAMINED"] = "NOT_SUBMITTED_EXAMINED";
    ReportType["COMPONENT_BUSINESS_RULES"] = "COMPONENT_BUSINESS_RULES";
    ReportType["PLAGIARISM_ALL_CANDIDATES"] = "PLAGIARISM_ALL_CANDIDATES";
    ReportType["PLAGIARISM_BY_QUERY"] = "PLAGIARISM_BY_QUERY";
    ReportType["PLAGIARISM_ERRORS"] = "PLAGIARISM_ERRORS";
    ReportType["SAMPLE_RERUN"] = "SAMPLE_RERUN";
    ReportType["RMA_ERRORS"] = "RMA_ERRORS";
})(ReportType = exports.ReportType || (exports.ReportType = {}));
exports.SUPPORTED_REPORTS_REQUEST_TYPES = [
    ReportType.SUBMITTED_EXAMINED,
    ReportType.SUBMITTED_MODERATED,
    ReportType.NOT_SUBMITTED_EXAMINED,
    ReportType.NOT_SUBMITTED_MODERATED,
    ReportType.SAMPLE_RERUN,
    ReportType.TRAINING,
];
